import React, { Component } from 'react';

import { YesNoDialog } from 'Components';

class DeleteDialog extends Component {
  render() {
    const { vendor, shown, onConfirm, onCancel } = this.props;

    if (!vendor) {
      return null;
    }

    return (
      <YesNoDialog
        showDialog={shown}
        title={`Delete Distributor - ${vendor.Description}`}
        question={`Are you sure you want delete this distributor?`}
        yesCallback={onConfirm}
        noCallback={onCancel}
      />
    );
  }
}

export { DeleteDialog };



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/DeleteDialog.js